@if (isAuthenticated()) {
  <div>
    <br>
      <div class="row mt-3">
        <div class="col">
          @if (multipleMembers()) {
            <div>
              <div class="row justify-content-between">
                <div class="col">
                  <h2>Farm Overview</h2>
                </div>
                <div class="dropdown" dropdown>
                  <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light">
                    {{ this.lS.selectedmembername }}<span class="caret"></span></a>
                    <ul *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
                      @for (mship of this.lS.memberships; track mship) {
                        <button
                          class="dropdown-item waves-light py-3"
                         
                          (click)="onMemberSelected(mship['membership'], mship['companyname'])"
                        >{{ mship['companyname'] }}</button>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            }
            @if (!multipleMembers()) {
              <div>
                <div class="row justify-content-between">
                  <div class="col-xs-6 ms-3">
                    <h2>Farm Overview</h2>
                  </div>
                  <div class="me-4 ms-3">
                    <h4>{{ this.lS.selectedmembername }}</h4>
                  </div>
                </div>
              </div>
            }
            <br>
              <div class="col">
                <app-map></app-map>
              </div>
            </div>
          </div>
        </div>
      }
